import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PrintTemplateOption, PrintTemplateType } from '@digilize/shared/definitions/src';

@Injectable({ providedIn: 'root' })
export class PrintTemplatesApiService {
  private readonly base = '/api/v1.0/print-templates';

  constructor(private http: HttpClient) {}

  getPrintTemplates(type: PrintTemplateType) {
    return this.http.get<PrintTemplateOption[]>(this.base, { params: { type } });
  }

  /* The `type`/`key` pair is exactly what getPrintTemplates returned, and the BE validates the key against
     that same set - so a key the dropdown offered is a key this endpoint renders. `shop_id` is optional and
     omitted rather than sent empty (an empty value would fail the BE's Guid parse): on the shop CREATE page
     there is no shop yet, and the preview then renders against a stand-in shop. */
  templatePreviewUrl = (params: { type: PrintTemplateType; key: string; shopId?: string }) =>
    `${this.base}/${params.type}/preview?key=${encodeURIComponent(params.key)}${
      params.shopId ? `&shop_id=${encodeURIComponent(params.shopId)}` : ''
    }`;

  /* Blob GET, not a bare iframe src: the endpoint is JWT-authenticated and staff-only, and ApiInterceptor
     only attaches the bearer token to requests that go through HttpClient. These layouts are HTML (the PDF
     the customer receives), so the dialog renders the blob in an iframe. */
  getTemplatePreview = (params: { type: PrintTemplateType; key: string; shopId?: string }) =>
    this.http.get(this.templatePreviewUrl(params), { responseType: 'blob' });
}
